<template>
  <div class="animated fadeIn">
    <b-row>
        <PageTitle></PageTitle>
        <filter-area
          @filterData="filterData()"
          @resetData="resetFilerAreaData()"
        >
          <b-row>
            <b-col cols="4">
              <b-form-group>
                <label for="activeRadio">{{$t('filterArea.label.state')}}</label>
                <b-form-radio-group id="activeRadio"
                                    :plain="true"
                                    :options="activeRadioOptions"
                                    v-model="filterArea.state">
                </b-form-radio-group>
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-form-group>
                <label for="code">{{$t('filterArea.label.code')}}</label>
                <b-form-input
                  type="text"
                  id="code"
                  :placeholder="$t('filterArea.label.code')"
                  v-model="filterArea.code">
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-form-group>
                <label for="name">{{$t('filterArea.label.name')}}</label>
                <b-form-input
                  type="text"
                  id="name"
                  :placeholder="$t('filterArea.label.name')"
                  v-model="filterArea.name">
                </b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </filter-area>
      <b-col lg="12">
        <b-card>
          <b-table
            :stacked="stacked"
            :hover="hover"
            :striped="striped"
            :bordered="bordered"
            :small="small"
            :fixed="fixed"
            :items="items"
            :fields="captions"
            :current-page="1"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :per-page="perPage"
            @sort-changed="sortingChanged"
            :no-sort-reset="true"
            :no-local-sorting="true">
            <template slot="active" slot-scope="data">
              <c-switch class="mx-1" @change="updateStatus(data.item.id, data.item.active)" v-model="data.item.active" color="success" variant="pill" label/>
            </template>
            <template slot="actions" slot-scope="data">
              <div class="btn-group" role="group">
                <router-link tag="button" class="btn btn-primary fa fa-search" v-b-tooltip.hover :title="$t('actions.show')"
                             :to="{name: 'companyShowRoute', params:{id: data.item.id}}">
                </router-link>
                <router-link tag="button" class="btn btn-warning fa fa-edit" v-b-tooltip.hover :title="$t('actions.edit')"
                             :to="{name: 'companyEditRoute', params:{id: data.item.id}}">
                </router-link>
              </div>
            </template>
          </b-table>
          <div class="row">
            <div class="col-sm-4">
              <b-pagination :total-rows="rowCount" :per-page="perPage" v-model="currentPage" prev-text="Prec"
                            next-text="Succ"
                            hide-goto-end-buttons @input="fetchData(currentPage)"/>
            </div>
            <div class="col-sm-6"></div>
            <div class="col-sm-2">
              <router-link class="btn btn-primary btn-block float-right" role="button" :to="{path: `/company/new`}" push>
                {{ $t('actions.create') }}
              </router-link>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import miniToastr from 'mini-toastr' //ES6
  import PageTitle from '../../components/PageTitle'
  import CompanyService from "@/services/CompanyService"
  import i18n from '@/config/i18n'
  import CustomSwitch from '../../components/CustomSwitch'
  import FilterArea from '../../components/FilterArea'

  const companyService = CompanyService.build();

  export default {
    name: 'companyList',
    components: {
      PageTitle,
      cSwitch:CustomSwitch,
      FilterArea
    },
    props: {
      stacked: {
        type: String,
        default: 'sm'
      },
      hover: {
        type: Boolean,
        default: true
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      },
      perPage: {
        type: Number,
        default: 7
      }
    },
    data: () => {
      return {
        fields: [
          {
            key: 'active',
            sortable: false,
            label: i18n.tc('page.generic.state', 1)
          },
          {
            key: 'code',
            sortable: true,
            label: i18n.t('page.generic.code')
          },
          {
            key: 'label',
            sortable: true,
            label: 'Nome Company'
          },
          {
            key: 'modelsTotal',
            sortable: false,
            label: 'Modelli'
          },
          {
            key: 'actions',
            sortable: false,
            label: ''
          },
        ],
        currentPage: 1,
        tableData: [],
        tableTotalRows: 0,
        sortBy: 'code',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        activeRadioOptions: [
          {text: 'Attivo',value: true},
          {text: 'Disattivo',value: false},
        ],
        filterArea: {
          state: null,
          code: null,
          name: null
        }
      }
    },
    mounted: function () {
      miniToastr.init(); // config can be passed here miniToastr.init(config)
      miniToastr.setIcon('error', 'i', {'class': 'fas fa-exclamation-triangle'});
      this.fetchData(1)
    },
    created() {
      // fetch the data when the view is created and the data is
      // already being observed
    }
    ,
    computed: {
      items: function () {
        const items = this.tableData;
        return Array.isArray(items) ? items : []
      },
      captions: function () {
        return this.fields
      },
      rowCount: function () {
        return this.tableTotalRows
      }
    },
    methods: {
      async fetchData(currentPage) {
        this.error = this.tableData = [];
        let response = await companyService.search({
          max: this.perPage,
          offset: (currentPage - 1) * this.perPage,
          sort: this.sortBy,
          order: (this.sortDesc ? 'desc' : 'asc'),
          active: this.filterArea.state,
          code: this.filterArea.code,
          name: this.filterArea.name
        });

        this.tableData = response.data;
        this.tableTotalRows = response.total;
      },
      sortingChanged(ctx) {
        // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
        // ctx.sortDesc ==> true if sorting descending, false otherwise
        this.sortBy = ctx.sortBy;
        this.sortDesc = ctx.sortDesc;
        this.fetchData(this.currentPage)
      }
      ,
      async updateStatus(id, status) {
        try {
          await companyService.update({id: id, active: status})
          miniToastr.info(`Azienda ${status?'abilitata':'disabilitata'} con successo`);
        } catch (exception) {
          miniToastr.error(exception.message)
        }
      },
      filterData(){
        this.fetchData(1)
      },
      resetFilerAreaData(){
        this.filterArea = {
          state: null,
          code: null,
          name: null
        }
        this.fetchData(1)
      }
    }
  }
</script>
